const action = 'ENABLE_GOAL';

const attempt = () => {
  const result = {
    success: true
  };

  return result;
};

const executeSideEffects = (context, result) => {
  const {
    party: { history }
  } = context;

  history.add({ action, result }, context);

  return {};
};

const enableGoal = notifyDone => ({
  title: 'OK',
  enabled: () => true,
  execute: context => {
    const result = attempt(context);
    executeSideEffects(context, result);

    notifyDone();

    return {};
  }
});

export default enableGoal;
